/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Update_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update persona." |
*
* @param {Personas_Update_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_update_error = /** @type {((inputs?: Personas_Update_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Update_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Persona konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Failed to update persona.")
});